import { Circle } from '@mui/icons-material';
import { Avatar, Grid, Tooltip } from '@mui/material';
import DialogPreview from 'components/DialogPreview/DialogPreview';
import { Extension } from 'utilities/utilities';
import PDFIcon from "../../../../../assets/images/DocTypeIcon/PDF.svg";

const RenderCellFile = ({ isOpen, setIsOpen, arrFile = [] }) => {

    const handleOpenFile = (sFileLink) => {
        let sUrl = sFileLink;
        window.open(sUrl, "_blank", "noreferrer");
    };

    return (
        <DialogPreview
            IsOpen={isOpen}
            Title={`ไฟล์`}
            required={true}
            onClose={() => setIsOpen(false)}
            sMaxWidth="sm"
            CloseSave={true}
        >
            <Grid container spacing={2} justifyContent={"center"} alignItems={"center"}>
                {
                    arrFile.length > 0 ?
                        arrFile.map(m => {
                            let sFileType = m.sFileName.split(".")[m.sFileName.split(".").length - 1].toLowerCase();
                            return (
                                <Grid item xs={12} key={m.sFileName}>
                                    <Grid container alignItems={"center"} justifyContent={"space-between"}>
                                        <Grid item >
                                            <div onClick={() => handleOpenFile(m.sFileLink)} style={{ cursor: "pointer", color: "blue" }}>
                                                <Circle
                                                    sx={{
                                                        color: "blue",
                                                        height: "7px",
                                                        marginLeft: 1,
                                                    }}
                                                />
                                                {m.sFileName}
                                            </div>
                                        </Grid>
                                        <Grid item >
                                            {Extension.Image.includes(sFileType) && (
                                                <Grid item xs={12}>
                                                    <Tooltip title={`แสดงไฟล์`}>
                                                        <Avatar
                                                            alt=""
                                                            src={m.sFileLink}
                                                            sx={{ width: 40, height: 40, cursor: "pointer" }}
                                                            onClick={() => handleOpenFile(m.sFileLink)}
                                                        />
                                                    </Tooltip>
                                                </Grid>
                                            )}
                                            {sFileType === "pdf" && (
                                                <Grid item xs={12}>
                                                    <Tooltip title={`แสดงไฟล์`}>
                                                        <img
                                                            style={{ width: 30, height: 30, cursor: "pointer", margin: '0 4px' }}
                                                            src={PDFIcon}
                                                            alt=""
                                                            onClick={() => handleOpenFile(m.sFileLink)}
                                                        />
                                                    </Tooltip>
                                                </Grid>
                                            )}
                                        </Grid>
                                    </Grid >
                                </Grid >
                            );
                        })
                        :
                        null
                }
            </Grid>
        </DialogPreview>
    )
}

export default RenderCellFile